import React, { useState, useEffect } from "react";
import "./RatingsTable.css";
import SelectButton from "../SelectButton/SelectButton";
import MenuItem from "@mui/material/MenuItem";
import SearchIcon from "@mui/icons-material/Search";
import { useTranslation } from "react-i18next";

const RatingTableSelectors = ({
  setCourseHandicap,
  slopeRating,
  courseRating,
  totalPar,
  selectedGuide,
  setSelectedGuide,
  guides,
  selectedTeeId,
  setSelectedTeeId,
  selectedSex,
  setSelectedSex,
  teesData,
}) => {
  const [handicap, setHandicap] = useState("");
  const { t } = useTranslation();

  useEffect(() => {
    const handicapValidator = (handicap) => {
      if (handicap === "") {
        return false;
      }

      const regex = /^-?\d+(\.\d+)?$/;
      return regex.test(handicap);
    };

    if (courseRating && slopeRating && totalPar) {
      if (handicapValidator(handicap)) {
        const hcp = parseFloat(handicap);
        const raw = (hcp * slopeRating) / 113 + (courseRating - totalPar);
        const courseHandicap = Math.round(Number(raw.toFixed(10)));
        setCourseHandicap(courseHandicap);
      } else {
        setCourseHandicap(null);
      }
    }
  }, [
    selectedSex,
    selectedTeeId,
    courseRating,
    slopeRating,
    totalPar,
    handicap,
    setCourseHandicap,
  ]);

  const onHandicapChange = (handicap) => {
    const formattedInput = handicap.replace(",", ".");
    setHandicap(formattedInput);
  };

  // FIXME: We should filter tees and gender so we do not show combinations that has no rating
  // (see https://www.glfr.com/c/falmouth-golf-club?unit=yards as an example)
  // https://app.clickup.com/t/86c2tr2nx
  return (
    <div className="glfr-select-container">
      <div>
        <h1>{t("ratings")}</h1>
      </div>
      <div className="glfr-selectors">
        <div className="handicap-input">
          <input
            name="handicap"
            value={handicap}
            className="handicap-input-button"
            placeholder={t("handicap_placeholder")}
            onChange={(event) => onHandicapChange(event.target.value)}
          />
          <div style={{ flex: 1 }} className="handicap-input-icon">
            <SearchIcon />
          </div>
        </div>
        <SelectButton
          selectedItem={selectedGuide}
          setSelectedItem={setSelectedGuide}
          buttonText={selectedGuide ? selectedGuide.title : "Select guide"}
        >
          {(handleItemClick) => (
            <div>
              {guides.map((item) => (
                <MenuItem
                  key={item.title}
                  onClick={(event) => handleItemClick(event, item)}
                >
                  {item.title}
                </MenuItem>
              ))}
            </div>
          )}
        </SelectButton>
        <SelectButton
          selectedItem={selectedTeeId}
          setSelectedItem={setSelectedTeeId}
          buttonText={selectedTeeId ? selectedTeeId : "Select tee"}
        >
          {(handleItemClick) => (
            <div>
              {teesData.map((item) => (
                <MenuItem
                  key={item.name}
                  onClick={(event) => handleItemClick(event, item.name)}
                >
                  {item.name}
                </MenuItem>
              ))}
            </div>
          )}
        </SelectButton>
        <SelectButton
          selectedItem={selectedSex}
          setSelectedItem={setSelectedSex}
          buttonText={
            selectedSex
              ? selectedSex === "male"
                ? t("male")
                : t("female")
              : "Select gender"
          }
        >
          {(handleItemClick) => (
            <div>
              {[
                { value: "male", text: t("male") },
                { value: "female", text: t("female") },
              ].map((item) => (
                <MenuItem
                  key={item.value}
                  onClick={(event) => handleItemClick(event, item.value)}
                >
                  {item.text}
                </MenuItem>
              ))}
            </div>
          )}
        </SelectButton>
      </div>
    </div>
  );
};

export default RatingTableSelectors;
